module.exports = __webpack_public_path__ + "img/00_bogota.d12bc9b5.jpg";